import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <div className="container py-5 mt-3">
        <h1
          className="text-center mt-5 fw-bold"
          style={{ color: "rgba(78, 66, 80, 1)" }}
        >
          Terms and Conditions
        </h1>{" "}
        <div>
          <p className="mt-4">
            Please read these terms and conditions carefully before using Our
            Service.
          </p>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Interpretation and Definitions
          </h1>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Interpretation
          </h1>
          <p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Definitions
          </h1>
          <p>For the purposes of these Terms and Conditions:</p>
          <p>
            <strong>Company </strong>(referred to as either "the Company", "We",
            "Us" or "Our" in this Agreement) refers "AERO BEE STAR GLOBAL
            SOLUTIONS INDIA PRIVATE LIMITED", Forum DLF Cyber City, Phase III,
            DLF QE, Sector 24, Gurugram, Haryana, 122002.
          </p>
          <p>
            <strong>Service</strong> refers to the Website.
          </p>
          <p>
            <strong>Website</strong> refers to Our Website, accessible from
            <a href="https://aerogenie.co/"> https://aerogenie.co</a>
          </p>
          <p>
            <strong>You</strong> means the individual accessing or using the
            Service, or the company, or other legal entity on behalf of which
            such individual is accessing or using the Service, as applicable.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Acknowledgment
          </h1>
          <p>
            These are the Terms and Conditions governing the use of this Service
            and the agreement that operates between You and the Company. These
            Terms and Conditions set out the rights and obligations of all users
            regarding the use of the Service.
          </p>
          <p>
            Your access to and use of the Service is conditioned on Your
            acceptance of and compliance with these Terms and Conditions. These
            Terms and Conditions apply to all visitors, users and others who
            access or use the Service.
          </p>
          <p>
            By accessing or using the Service You agree to be bound by these
            Terms and Conditions. If You disagree with any part of these Terms
            and Conditions then You may not access the Service.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Termination
          </h1>
          <p>
            We may terminate or suspend Your access immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if You breach these Terms and Conditions.
          </p>
          <p>
            Upon termination, Your right to use the Service will cease
            immediately.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Limitation of Liability
          </h1>
          {/* <p>
            Notwithstanding any damages that You might incur, the entire
            liability of the Company and any of its suppliers under any
            provision of this Terms and Your exclusive remedy for all of the
            foregoing shall be limited to the amount actually paid by You
            through the Service or 100 USD if You haven't purchased anything
            through the Service.
          </p> */}
          <p>
            To the maximum extent permitted by applicable law, in no event shall
            the Company or its suppliers be liable for any special, incidental,
            indirect, or consequential damages whatsoever (including, but not
            limited to, damages for loss of profits, loss of data or other
            information, for business interruption, for personal injury, loss of
            privacy arising out of or in any way related to the use of or
            inability to use the Service, third-party software and/or
            third-party hardware used with the Service, or otherwise in
            connection with any provision of this Terms), even if the Company or
            any supplier has been advised of the possibility of such damages and
            even if the remedy fails of its essential purpose.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Governing Law
          </h1>
          <p>
            The laws of the Country, excluding its conflicts of law rules, shall
            govern this Terms and Your use of the Service. Your use of the
            Application may also be subject to other local, state, national, or
            international laws.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Changes to These Terms and Conditions
          </h1>
          <p>
            We reserve the right, at Our sole discretion, to modify or replace
            these Terms at any time. If a revision is material We will make
            reasonable efforts to provide at least 30 days' notice prior to any
            new terms taking effect. What constitutes a material change will be
            determined at Our sole discretion.
          </p>
          <p>
            By continuing to access or use Our Service after those revisions
            become effective, You agree to be bound by the revised terms. If You
            do not agree to the new terms, in whole or in part, please stop
            using the website and the Service.
          </p>
        </div>
        <div>
          <h1 className="fw-bold" style={{ color: "rgba(78, 66, 80, 1)" }}>
            Contact Us
          </h1>
          <p>
            If you have any questions about these Terms and Conditions, You can
            contact us:
          </p>
          <p>
            Email: <a href="mailto:info@aerogenie.co">info@aerogenie.co</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
